import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Button, CardHeader } from "reactstrap";
import CreateButton from "../../../CommonElements/Button/CreateButton";
import Transaksi from "../components/Transaksi";
import TandaTerima from "../components/TandaTerima";
import GroupTransaksi from "../components/GroupTransaksi";
import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import { FEATURE_FUNCTION_SELECTION } from "../../../Constant/FeatureSelection";
import useAxios from "../../../Utils/useAxios";
import {
  getGroupDokumenTransaksi,
  getTransaksi,
  getTransaksiView,
  getUMO,
  getUnitKerja,
} from "../services";
import getTransaksiLayout from "../../../Layout/Components/new/getTransaksi";

const ACTIVE_COMPONENT = {
  transaksi: "transaksi",
  tandaterima: "tandaterima",
  grouptransaksi: "grouptransaksi",
};

const TransaksiContain = () => {
  const { selectedComponent } = useParams();
  const axiosInstance = useAxios();

  const [data, setData] = useState({
    transaksiList: [],
    unitKerja: [],
    umoList: [],
    groupDokumenTransaksiList: [],
  });

  const [activeComponent, setActiveComponent] = useState("Transaksi");
  const [pending, setPending] = useState({
    transaksi: false,
    groupdokumentransaksi: false,
    statusTransaksi: false,
  });

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      if (activeComponent === ACTIVE_COMPONENT.transaksi) {
        await refreshTransaksi();

        const { data: unitKerjaData } = await getUnitKerja(axiosInstance);
        setData((prev) => ({ ...prev, unitKerja: unitKerjaData }));

        const { data: umoData } = await getUMO(axiosInstance);
        setData((prev) => ({ ...prev, umoList: umoData }));
      } else {
        setPending((prev) => ({ ...prev, groupdokumentransaksi: true }));

        const { data: groupDokumenTransaksiData } =
          await getGroupDokumenTransaksi(axiosInstance).then((res) => {
            setPending((prev) => ({ ...prev, groupdokumentransaksi: false }));
            return res;
          });
        setData((prev) => ({
          ...prev,
          groupDokumenTransaksiList: groupDokumenTransaksiData,
        }));
      }
    };

    if (isMounted) fetchData();

    return () => {
      isMounted = false;
    };
  }, [activeComponent]);

  useEffect(() => {
    if (selectedComponent) handleButtonClick(selectedComponent);
    else handleButtonClick("transaksi");
  }, [selectedComponent]);

  const refreshTransaksi = async () => {
    setPending((prev) => ({
      ...prev,
      transaksi: true,
      statusTransaksi: true,
    }));

    // const { data: transaksiData } = await getTransaksiLayout(axiosInstance, {
    //   page: 31,
    //   pagecount: 100,
    // })
    const { data: transaksiData } = await getTransaksi(axiosInstance).finally(
      () =>
        setPending((prev) => ({
          ...prev,
          transaksi: false,
          statusTransaksi: false,
        }))
    );
    setData((prev) => ({ ...prev, transaksiList: transaksiData }));
    return transaksiData;
  };

  const handleButtonClick = (componentName) => {
    setActiveComponent(componentName);
  };

  return (
    <FeatureContainer
      title={"Transaksi"}
      statusList={
        activeComponent === ACTIVE_COMPONENT.transaksi && data.transaksiList
      }
      pending={pending?.statusTransaksi}
      refreshList={refreshTransaksi}
      createButton={
        FEATURE_FUNCTION_SELECTION.Transaksi.Create && (
          <CreateButton
            url={`${process.env.PUBLIC_URL}/transaksi/buattransaksi`}
          >
            Buat Transaksi Baru
          </CreateButton>
        )
      }
    >
      <CardHeader className={"pt-0"}>
        <TransaksiNavbar activeComponent={activeComponent} />
      </CardHeader>

      {activeComponent === ACTIVE_COMPONENT.transaksi && (
        <Transaksi
          data={data}
          pending={pending?.transaksi}
          refreshTransaksi={refreshTransaksi}
        />
      )}
      {activeComponent === ACTIVE_COMPONENT.tandaterima && (
        <TandaTerima
          groupDokumenTransaksiList={data.groupDokumenTransaksiList}
          pending={pending?.groupdokumentransaksi}
        />
      )}
      {activeComponent === ACTIVE_COMPONENT.grouptransaksi && (
        <GroupTransaksi />
      )}
    </FeatureContainer>
  );
};

const TransaksiNavbar = ({ activeComponent }) => {
  return (
    <div className="row row-cols-sm-3 row-cols-xl-5 text-center justify-content-center ">
      <Link
        className="p-0 d-flex align-items-stretch"
        to={`${process.env.PUBLIC_URL}/transaksi`}
      >
        <Button
          className="w-100"
          active={activeComponent === ACTIVE_COMPONENT.transaksi}
          // style={{
          //   "border-top-left-radius": "6px",
          //   "border-bottom-left-radius": "6px",
          // }}
        >
          Lihat Transaksi
        </Button>
      </Link>
      <Link
        className="p-0 d-flex align-items-stretch"
        to={`${process.env.PUBLIC_URL}/transaksi/tandaterima`}
      >
        <Button
          className="w-100"
          active={activeComponent === ACTIVE_COMPONENT.tandaterima}
        >
          Lihat Tanda Terima
        </Button>
      </Link>
      <Link
        className="p-0 d-flex align-items-stretch"
        to={`${process.env.PUBLIC_URL}/transaksi/grouptransaksi`}
      >
        <Button
          className="w-100"
          active={activeComponent === ACTIVE_COMPONENT.grouptransaksi}
        >
          Ajukan Tanda Terima
        </Button>
      </Link>
    </div>
  );
};

export default TransaksiContain;
